module.exports = "/_next/static/chromiums/og-1200x630-products-peppermint-creme-lip-balm-0c9b7dd8c2218bc1b2facb2461f5b005.jpg";